import React, { useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import config from '../../config.js';
import DataSourceDropDown from './DataSourceDropDown'
import DataSources from './DataSources';

function AdminDataSouceScreen() {

    const [sources, setSources] = useState([]);
    const [savedsources, setSavedSources] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [conductReload, setConductReload] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const config_home = useMemo(() => ({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token')
        }
    }), []);
    // Loading sources from master fulfillment sources (used in the dropdown menu)
    const loadMasterFulfillmentSources = useCallback(async () => {
        try {
            const response = await axios.get(`${config.serviceUrl}/fulfillment-sources-master/list`, config_home);
            if (response.status === 200) {
                setSources(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    }, [config_home]);
    // Loading sources for the already configured fulfillment sources (used as cards)
    const loadAddedFulfillmentSources = useCallback(async () => {
        try {
            if (isInitialLoad) setIsLoading(true);
            const response = await axios.get(`${config.serviceUrl}/fulfillment-source/list`, config_home);
            if (response.status === 200) {
                setSavedSources(response.data);
            }
        } catch (error) {
            try {
                setErrorMessage(error.response.data.message);
            } catch (error) {
                setErrorMessage('Unable to Display Fulfillment Sources.');
            }
        } finally {
            setIsLoading(false);
            setIsInitialLoad(false);
        }
    }, [config_home, isInitialLoad]);

    // Hook for getting fulfillment sources
    useEffect(() => {
        loadMasterFulfillmentSources();
        loadAddedFulfillmentSources();
    }, [conductReload, loadMasterFulfillmentSources, loadAddedFulfillmentSources]);

    return (
        <div className="content bg-gray-100 dark:bg-gray-900 h-full">
            <div style={{ height: "54px" }} className="mb-3"> </div>

            {errorMessage ? <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mx-4">{errorMessage}</div>
                :
                <>
                    <DataSourceDropDown
                        sources={sources}
                        setConductReload={setConductReload}
                        errorMessage={errorMessage}
                    />

                    <DataSources
                        savedsources={savedsources}
                        isLoading={isLoading}
                        setConductReload={setConductReload}
                    />
                </>
            }

        </div>
    )
}

export default AdminDataSouceScreen
